module.exports = __webpack_public_path__ + "static/img/infractions.064b1a54.png";